import React from 'react';
import LoadingIcon from '../share/LoadingIcon';
import Invoice from '@/app/_components/ui/icons/Invoice.svg';
import { useState } from 'react';
import useProformaInvoice from '@/app/_hooks/useProformaInvoice';
import Link from 'next/link';

export default function AddToInvoiceButton({
  currentVariationId,
  productId,
  showInList = false,
}) {
  const { invoice, addProduct } = useProformaInvoice();
  const addToInvoice = () => {
    const product = {
      productId: productId,
      priceId: currentVariationId,
      quantity: 1,
    };
    addProduct(product);
  };
  const invoiceItem = invoice?.items?.find(
    (item) =>
      item.productId === productId && item.priceId === currentVariationId
  );
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  return (
    <div className="relative">
      {invoiceItem ? (
        <div className="relative group">
          <div className="absolute -left-2 -top-2 rounded-full text-white bg-red-300 w-5 h-5 flex items-center justify-center text-xs text-gray-700">
            {invoiceItem.quantity}
          </div>
          <div
            className={` bg-light-green-100 border border-green-heavy ${
              showInList ? 'p-1.5' : 'p-3 mr-2'
            }  rounded-md text-sm  `}
          >
            <Link href="/page/proforma-invoice/">
              <Invoice fill="#08A54A" />
            </Link>
          </div>

          <div class="hidden sm:absolute left-1/2 -translate-x-1/2 -bottom-8 w-max px-3 py-2 text-xs text-white bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
            مشاهده پیش فاکتور
            <div class="absolute left-1/2 -top-1 m w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-gray-700"></div>
          </div>
        </div>
      ) : (
        <div className="relative group cursor-pointer">
          <div
            className={` bg-light-green-100 border border-green-heavy ${
              showInList ? 'p-1.5' : 'p-3 mr-2'
            }  rounded-md text-sm  `}
            onClick={addToInvoice}
          >
            {isAddingToCart ? (
              <LoadingIcon />
            ) : (
              <div className="flex justify-center ">
                <Invoice fill="#08A54A" />
              </div>
            )}
          </div>
          <div class="hidden sm:absolute left-1/2 -translate-x-1/2 -bottom-8 w-max px-3 py-2 text-xs text-white bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
            افزودن به پیش فاکتور
            <div class="absolute left-1/2 -top-1 -translate-x-1/2 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-gray-700"></div>
          </div>
        </div>
      )}
    </div>
  );
}
